'use strict';

/**
 * MY.LAB — fiche produit.
 *
 * Trois responsabilités, aucune librairie :
 *   1. la barre d'ancres, construite depuis le DOM pour ne jamais pointer
 *      vers une section absente ;
 *   2. la barre d'achat collante, qui soumet le formulaire natif de Dawn
 *      au lieu d'en créer un second ;
 *   3. l'ajout indépendant des produits de routine, sur le même chemin que
 *      le catalogue (assets/ml-catalog.js) pour un seul comportement panier ;
 *   4. les paliers de quantité, lus dans assets/ml-product-map.json (la carte
 *      de Be Yours, celle que Shopify facture) : sélecteur, tableau, meilleur
 *      palier du format pro. Voir snippets/ml-quantite-paliers.liquid.
 *
 * Aucune remise n'est décidée ici : elles appartiennent à Shopify / One Stop.
 * Le total affiché sous les paliers reprend leurs prix, il ne les invente pas.
 */
(function () {
  // Plusieurs sections chargent ce fichier : quatre balises <script src> identiques
  // s'exécutent quatre fois, pas une. Sans ce verrou, la barre d'ancres se
  // remplissait en quadruple et un clic « Ajouter » de la routine aurait posté
  // quatre fois le même produit au panier. Constaté sur le brouillon le 21/09/2026.
  if (window.__mlProductPageAmorce) return;
  window.__mlProductPageAmorce = true;

  /* ---------- barre d'ancres ---------- */

  function construireNav() {
    var nav = document.querySelector('[data-ml-pp-nav]');
    if (!nav) return;

    var liste = nav.querySelector('[data-ml-pp-nav-list]');
    var cibles = Array.prototype.slice.call(document.querySelectorAll('[data-ml-anchor]'));

    // Une section absente n'a pas d'ancre : on ne fabrique que ce qui existe.
    cibles = cibles.filter(function (cible) {
      return cible.id && cible.getAttribute('data-ml-anchor');
    });

    if (!liste || cibles.length < 2) {
      nav.remove();
      return;
    }

    cibles.forEach(function (cible) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + cible.id;
      a.textContent = cible.getAttribute('data-ml-anchor');
      li.appendChild(a);
      liste.appendChild(li);
    });

    nav.hidden = false;
    surlignerAuDefilement(nav, cibles);
  }

  function surlignerAuDefilement(nav, cibles) {
    if (!('IntersectionObserver' in window)) return;

    var liens = {};
    nav.querySelectorAll('a').forEach(function (a) {
      liens[a.getAttribute('href').slice(1)] = a;
    });

    var visibles = {};

    var observateur = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (entree) {
          visibles[entree.target.id] = entree.isIntersecting;
        });

        var courant = null;
        for (var i = 0; i < cibles.length; i++) {
          if (visibles[cibles[i].id]) {
            courant = cibles[i].id;
            break;
          }
        }

        Object.keys(liens).forEach(function (id) {
          if (id === courant) {
            liens[id].setAttribute('aria-current', 'true');
          } else {
            liens[id].removeAttribute('aria-current');
          }
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );

    cibles.forEach(function (cible) {
      observateur.observe(cible);
    });
  }

  /* ---------- barre d'achat collante ---------- */

  function brancherBarre() {
    var barre = document.querySelector('[data-ml-pp-sticky]');
    if (!barre) return;

    var bouton = barre.querySelector('[data-ml-pp-sticky-submit]');
    var reference = document.querySelector('product-info [name="add"]');

    // On ne duplique pas le formulaire : on emprunte celui de Dawn. On passe
    // par `.form` du bouton natif plutôt que par un sélecteur, parce que Dawn
    // rend DEUX formulaires qui postent sur /cart/add — celui du panier et
    // celui du paiement en plusieurs fois. Un sélecteur attrapait le second.
    var formulaire = reference ? reference.form : null;

    if (!formulaire || !bouton || !reference) {
      barre.remove();
      return;
    }

    // Piège HTML : un formulaire expose ses champs comme propriétés, et le
    // formulaire produit de Shopify contient <input name="id"> pour la variante.
    // `formulaire.id` renvoie donc cet input, pas l'identifiant du formulaire —
    // l'attribut `form` valait « [object HTMLInputElement] » et le bouton ne
    // soumettait rien. Constaté sur le brouillon le 21/09/2026. Passer par
    // getAttribute/setAttribute est la seule lecture fiable.
    var identifiant = formulaire.getAttribute('id');
    if (!identifiant) {
      identifiant = 'ml-pp-form-' + Math.random().toString(36).slice(2, 8);
      formulaire.setAttribute('id', identifiant);
    }
    bouton.setAttribute('form', identifiant);
    barre.hidden = false;

    // Le libellé et l'état suivent le bouton natif : une rupture reste une rupture.
    function refleter() {
      bouton.disabled = reference.disabled;
      var texte = reference.querySelector('span');
      var libelle = (texte ? texte.textContent : reference.textContent) || '';
      libelle = libelle.trim();
      if (libelle) bouton.textContent = libelle;
    }

    refleter();
    new MutationObserver(refleter).observe(reference, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    // La quantité affichée vient du formulaire, jamais d'un calcul maison : le
    // palier coché d'une formule, sinon le champ natif de Dawn. Les paliers
    // sont reconstruits après le chargement de la carte, d'où l'écoute sur le
    // document plutôt que sur un champ précis.
    var compteur = barre.querySelector('[data-ml-pp-sticky-qty]');
    if (compteur && document.querySelector('product-info [name="quantity"]')) {
      var motUn = compteur.getAttribute('data-unite-singulier') || 'unité';
      var motPlusieurs = compteur.getAttribute('data-unite-pluriel') || 'unités';
      var refleterQuantite = function () {
        var champ =
          document.querySelector('product-info [name="quantity"]:checked') ||
          document.querySelector('product-info [name="quantity"]');
        var n = parseInt(champ ? champ.value : '', 10);
        if (!n || n < 1) n = 1;
        compteur.textContent = n + ' ' + (n > 1 ? motPlusieurs : motUn);
      };
      var siQuantite = function (evenement) {
        if (evenement.target && evenement.target.name === 'quantity') refleterQuantite();
      };
      refleterQuantite();
      document.addEventListener('change', siQuantite);
      document.addEventListener('input', siQuantite);
    }

    // La barre ne s'affiche que lorsque le bouton natif a quitté l'écran.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entrees) {
          barre.classList.toggle('is-shown', !entrees[0].isIntersecting);
        },
        { rootMargin: '0px 0px -10px 0px' }
      ).observe(reference);
    } else {
      barre.classList.add('is-shown');
    }
  }

  /* ---------- argumentaire : copie ---------- */

  function brancherCopie() {
    document.querySelectorAll('[data-ml-pp-copy]').forEach(function (bouton) {
      var cible = document.getElementById(bouton.getAttribute('data-ml-pp-copy'));
      var etat = bouton.parentElement
        ? bouton.parentElement.querySelector('[data-ml-pp-copy-status]')
        : null;
      if (!cible || !navigator.clipboard) {
        bouton.remove();
        return;
      }
      bouton.addEventListener('click', function () {
        navigator.clipboard.writeText(cible.textContent.trim()).then(
          function () {
            if (etat) etat.textContent = 'Argumentaire copié.';
          },
          function () {
            if (etat) etat.textContent = 'Copie impossible. Sélectionnez le texte à la main.';
          }
        );
      });
    });
  }

  /* ---------- routine : ajout indépendant ---------- */

  function tiroir() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function brancherRoutine() {
    var etat = document.querySelector('[data-ml-pp-routine-status]');

    function annoncer(message) {
      if (etat) etat.textContent = message;
    }

    document.querySelectorAll('[data-ml-pp-routine-add]').forEach(function (bouton) {
      bouton.addEventListener('click', function (evenement) {
        evenement.preventDefault();
        if (bouton.disabled) return;

        var id = bouton.getAttribute('data-variant');
        var nom = bouton.getAttribute('data-nom') || 'Ce produit';
        var cible = tiroir();
        // Premier palier du produit (6, ou 1 en 1000 ml), rendu par le serveur.
        var ligne = { id: Number(id), quantity: parseInt(bouton.getAttribute('data-quantite'), 10) || 1 };
        // Meme mention que le bouton principal (snippets/ml-stock-etat.liquid).
        if (bouton.getAttribute('data-etat') === 'sur-commande') {
          ligne.properties = { 'Expédition': 'Sur commande, dès réapprovisionnement' };
        }
        var corps = { items: [ligne] };

        if (cible && typeof cible.getSectionsToRender === 'function') {
          corps.sections = cible.getSectionsToRender().map(function (s) {
            return s.id;
          });
          corps.sections_url = window.location.pathname;
          if (typeof cible.setActiveElement === 'function') cible.setActiveElement(bouton);
        }

        var libelleInitial = bouton.textContent;
        bouton.disabled = true;
        bouton.textContent = 'Ajout…';

        fetch(
          (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') +
            '.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(corps)
          }
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (reponse) {
            if (reponse.status) {
              // Rupture ou refus serveur : le dire, ne pas faire comme si.
              annoncer(reponse.description || reponse.message || 'Ajout impossible.');
              bouton.textContent = 'Indisponible';
              return;
            }
            if (cible && typeof cible.renderContents === 'function') {
              cible.renderContents(reponse);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            annoncer(nom + ' ajouté à votre panier.');
            bouton.textContent = 'Ajouté ✓︎';
            setTimeout(function () {
              bouton.textContent = libelleInitial;
              bouton.disabled = false;
            }, 1600);
          })
          .catch(function () {
            annoncer("L'ajout n'a pas abouti. Réessayez.");
            bouton.textContent = 'Réessayer';
            bouton.disabled = false;
          });
      });
    });
  }

  /* ---------- paliers : la carte de Be Yours ---------- */

  var carte = null;

  function paliersDe(handle) {
    var U = window.MylabUtils;
    if (!U || !handle) return Promise.resolve([]);
    if (!carte) carte = U.loadProductMap();
    return carte.then(function (donnees) {
      return U.parseTierString(U.findTiers(handle, donnees));
    });
  }

  function prixHT(centimes) {
    return window.MylabUtils.formatPrice(centimes) + ' HT';
  }

  function surlignerPalier() {
    var coche = document.querySelector('[data-ml-qte] input:checked');
    document.querySelectorAll('[data-ml-paliers] tr[data-qte]').forEach(function (tr) {
      tr.classList.toggle('is-on', !!coche && tr.getAttribute('data-qte') === coche.value);
    });
  }

  function brancherPaliers() {
    var zone = document.querySelector('[data-ml-qte]');
    if (!zone) return;
    var choix = zone.querySelector('[data-ml-qte-choix]');
    var total = zone.querySelector('[data-ml-qte-total]');
    var modele = choix ? choix.querySelector('input[name="quantity"]') : null;
    if (!modele) return;
    var formulaire = modele.getAttribute('form');

    paliersDe(zone.getAttribute('data-handle'))
      .then(function (paliers) {
        // Absent de la carte : le premier palier rendu par le serveur reste seul.
        if (!paliers.length) return;
        var base = paliers[0].price;
        choix.textContent = '';
        paliers.forEach(function (palier, i) {
          var remise = Math.round((1 - palier.price / base) * 100);
          var etiquette = document.createElement('label');
          etiquette.className = 'ml-qte__palier';
          var radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'quantity';
          radio.value = String(palier.qty);
          radio.setAttribute('form', formulaire);
          radio.setAttribute('data-prix', String(palier.price));
          radio.checked = i === 0;
          etiquette.appendChild(radio);
          etiquette.insertAdjacentHTML(
            'beforeend',
            '<span class="ml-qte__nombre">' + palier.qty + '</span>' +
              '<span class="ml-qte__unite">' + (palier.qty > 1 ? 'unités' : 'unité') + '</span>' +
              (remise > 0 ? '<span class="ml-qte__remise">−' + remise + ' %</span>' : '')
          );
          choix.appendChild(etiquette);
        });

        var refleter = function () {
          var coche = choix.querySelector('input:checked');
          if (!coche) return;
          var n = parseInt(coche.value, 10);
          var prix = parseInt(coche.getAttribute('data-prix'), 10);
          if (total) total.textContent = n + ' × ' + prixHT(prix) + ' = ' + prixHT(n * prix);
          surlignerPalier();
        };
        choix.addEventListener('change', refleter);
        refleter();
        // La barre collante relit la quantité sur cet évènement.
        choix.querySelector('input:checked').dispatchEvent(new Event('change', { bubbles: true }));
      })
      .catch(function () {
        // Carte indisponible : on reste au premier palier rendu par le serveur.
      });
  }

  function remplirTableau() {
    document.querySelectorAll('[data-ml-paliers]').forEach(function (bloc) {
      var lignes = bloc.querySelector('[data-ml-paliers-lignes]');
      if (!lignes) return;
      paliersDe(bloc.getAttribute('data-handle'))
        .then(function (paliers) {
          if (!paliers.length) return;
          lignes.textContent = '';
          paliers.forEach(function (palier, i) {
            var suivant = paliers[i + 1];
            var tr = document.createElement('tr');
            tr.setAttribute('data-qte', String(palier.qty));
            var th = document.createElement('th');
            th.scope = 'row';
            if (!suivant) th.textContent = palier.qty + ' et plus';
            else if (suivant.qty - 1 === palier.qty) th.textContent = String(palier.qty);
            else th.textContent = palier.qty + ' à ' + (suivant.qty - 1);
            var td = document.createElement('td');
            td.textContent = prixHT(palier.price);
            tr.appendChild(th);
            tr.appendChild(td);
            lignes.appendChild(tr);
          });
          surlignerPalier();
          bloc.hidden = false;
        })
        .catch(function () {});
    });
  }

  function remplirMeilleurPalier() {
    document.querySelectorAll('[data-ml-meilleur-palier]').forEach(function (ligne) {
      paliersDe(ligne.getAttribute('data-handle'))
        .then(function (paliers) {
          if (!paliers.length) return;
          var mention = ligne.getAttribute('data-mention') || '';
          ligne.textContent = (mention ? mention + ' ' : '') + prixHT(paliers[paliers.length - 1].price);
          ligne.hidden = false;
        })
        .catch(function () {});
    });
  }

  /* ---------- amorçage ---------- */

  function demarrer() {
    construireNav();
    brancherBarre();
    brancherCopie();
    brancherRoutine();
    remplirTableau();
    brancherPaliers();
    remplirMeilleurPalier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
